// assets/huggle-countdown.js
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatDiff(ms) {
    if (ms <= 0) return { expired: true, text: '0T 00:00:00' };
    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;
    return {
      expired: false,
      text: (days > 0 ? days + 'T ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
    };
  }

  function initOne(el, endISO) {
    var until = Date.parse(endISO);
    if (isNaN(until)) { el.textContent = ''; return; }

    function tick() {
      var now = Date.now();
      var diff = until - now;
      var res = formatDiff(diff);
      if (res.expired) {
        el.textContent = 'Aktion beendet';
        el.classList.add('amaflow-countdown--expired');
        el.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true }));
        clearInterval(timer);
        return;
      }
      el.textContent = res.text;
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function initScope(scope) {
    scope.querySelectorAll('[data-countdown-end]').forEach(function (el) {
      var endISO = el.getAttribute('data-countdown-end');
      if (endISO) initOne(el, endISO);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initScope(document); });
  } else {
    initScope(document);
  }

  // Expose to Theme sections that re-render dynamically
  window.AmafCountdown = { init: initScope };
})();
